<template>
    <div>
        <error-page code="404" :description="description"></error-page>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import ErrorPage from './Error'
    
    export default {
        created: function() {
            this.switchLayout('error');
        },
        data: function() {
            return {
                description: 'We couldn\'t find this page!',
            }
        },
        methods: {
            ...mapActions([
                'switchLayout',
            ]),
        },
        components: {
            ErrorPage,
        }
    }
</script>



// WEBPACK FOOTER //
// 404.vue?052756dd